import React, { useState } from "react";
import cx from "clsx";
import { Box } from "../../../../../../shared/Box/Box";
import { Table as SharedTable } from "../../../../../../shared/Table/Table";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { Skeleton } from "../../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../../shared/Empty/Empty";
import { LoadMoreObserver } from "../../../../../../shared/LoadMoreObserver/LoadMoreObserver";
import classes from "./styles.module.scss";
import { SortAdornment } from "../../../../../../shared/SortAdornment/SortAdornment";
import { ORDER_BY } from "../../../../../../api/shopifyReports/useShopifyPatientOrdersReportQuery";
import { PageOverlayLoader } from "../../../../../../shared/PageOverlayLoader/PageOverlayLoader";
import { ShopifyProductsModal } from "../../../../../../widgets/ShopifyProductsModal";

export function Table({ reports, order }) {
  var { tCommon } = useAppTranslation.Common();
  var { tClients: t } = useAppTranslation.Clients();

  var isEmpty = reports.value.length === 0 && !reports.isLoading;
  var isVisible = !reports.isLoading && !isEmpty;
  var { 0: products, 1: setProducts } = useState(null);

  var data = reports.value.map((r) => ({
    id: r.id,
    bi_order: r.bi_order || tCommon("symbol.longDash"),
    bi_client_name: r.bi_client_name || tCommon("symbol.longDash"),
    bi_email: r.bi_email || tCommon("symbol.longDash"),
    bi_phone: r.bi_phone || tCommon("symbol.longDash"),
    bi_total: r.bi_total || tCommon("symbol.longDash"),
    bi_payment_status: r.bi_payment_status || tCommon("symbol.longDash"),
    bi_fulfillment_status:
      r.bi_fulfillment_status || tCommon("symbol.longDash"),
    bi_items: r.bi_items || tCommon("symbol.longDash"),
    bi_date: r.bi_date || tCommon("symbol.longDash"),
    products: r.products || [],
  }));

  var renderSortWrap = (children, field) => (
    <SortAdornment
      value={order.value.by === field ? order.value.direction : undefined}
      onToggle={() => order.update(field)}
    >
      {children}
    </SortAdornment>
  );

  return (
    <Box>
      {reports.isSoftLoading && <PageOverlayLoader />}
      {reports.isLoading && !reports.isSoftLoading && (
        <Skeleton count={15} height={40.5} borderRadius="0px" />
      )}
      {isEmpty && <Empty position="center" />}
      {isVisible && (
        <div className={classes.tableWrapper}>
          <SharedTable
            bgColor="white"
            keyExtractor={(row) => row.id}
            data={data}
            onRowClick={(row) => {
              setProducts(row.products);
            }}
            cols={[
              {
                data: renderSortWrap(
                  t("shopify_orders.table.order"),
                  ORDER_BY.order,
                ),
                accessor: "bi_order",
                className: classes.col,
              },
              {
                data: renderSortWrap(
                  t("shopify_orders.table.patient_name"),
                  ORDER_BY.clientName,
                ),
                accessor: "bi_client_name",
                className: classes.col,
              },
              {
                data: t("shopify_orders.table.email"),
                accessor: "bi_email",
                className: classes.emailCol,
              },
              {
                data: t("shopify_orders.table.phone"),
                accessor: "bi_phone",
                className: classes.col,
              },
              {
                data: renderSortWrap(
                  t("shopify_orders.table.total_sales"),
                  ORDER_BY.total,
                ),
                accessor: "bi_total",
                className: classes.col,
              },
              {
                data: renderSortWrap(
                  t("shopify_orders.table.payment_status"),
                  ORDER_BY.paymentStatus,
                ),
                accessor: "bi_payment_status",
                className: classes.col,
              },
              {
                data: renderSortWrap(
                  t("shopify_orders.table.fulfillment_status"),
                  ORDER_BY.fulfillmentStatus,
                ),
                accessor: "bi_fulfillment_status",
                className: cx(classes.col, classes.fulfillmentStatus),
              },
              {
                data: t("shopify_orders.table.items"),
                accessor: "bi_items",
                className: classes.col,
              },
              {
                data: renderSortWrap(tCommon("label.date"), ORDER_BY.date),
                accessor: "bi_date",
                className: classes.col,
              },
            ]}
          />
          {reports.hasMore && (
            <LoadMoreObserver
              noPaddingBottom
              loadMore={reports.fetchMore}
              isLoading={reports.isNextFetching}
            />
          )}
        </div>
      )}
      {Boolean(products) && (
        <ShopifyProductsModal
          isOpen
          onClose={() => setProducts(null)}
          products={products}
        />
      )}
    </Box>
  );
}
